import {
	RealtimeAlertsState,
	REALTIME_ALERTS_ACTION_TYPES,
	RealtimeAlertsAction,
} from '../../../types/realtimeAlerts'

const initialState: RealtimeAlertsState = {
	list: [],
}

export default (
	state: RealtimeAlertsState = initialState,
	action: RealtimeAlertsAction
): RealtimeAlertsState => {
	switch (action.type) {
		case REALTIME_ALERTS_ACTION_TYPES.GET: {
			return {
				list: action.payload,
			}
		}
		default: {
			return state
		}
	}
}
